import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=6fbd88a6&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=6fbd88a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd88a6",
  null
  
)

export default component.exports